//Below are the allowed characters suggested by business. Inconsistency with name validation of ShippingAddress during checkout.
const STANDARD = 'a-zßA-Zẞ'
const GRAVIS = 'àÀèÈìÌòÒùÙ'
const NASAL = 'ñõãÑÕÃ'
const SPECIAL_CHARACTERS = String.raw`Çç' \-._&/,~’‘`
const AKUT = 'áÁéÉíÍóÓúÚýÝ'
const ZIRCUMFLEX = 'âÂêÊîÎôÔûÛ'
const TREMA = 'ÄäǞǟЁёëḦḧÏïÖöȪȫṎṏÜüǕǖǗǘǙǚǛǜṺṻẄẅẌẍŸÿ'

const ALLOWED_CHARACTERS = `${STANDARD}${GRAVIS}${AKUT}${ZIRCUMFLEX}${NASAL}${TREMA}${SPECIAL_CHARACTERS}`

const charactersOnlyRegExp = new RegExp(`^[${ALLOWED_CHARACTERS}]+$`, 'u')

export const loginRegistrationIsAllowedCharactersForName = (
  value: string,
): boolean => {
  return charactersOnlyRegExp.test(value)
}
